import React, { memo, Fragment, useEffect, useCallback } from 'react';
import { FormInput } from '@core/components/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { Col, Row, Label } from 'reactstrap';
import { SortableList } from '@modules/common/Sortable';
import { R } from '@core/utils/r';
import { SortableElement, SortableHandle, SortEnd } from 'react-sortable-hoc';
import { SequenceItemForm, SequenceDrillWidgetForm, SequenceForm } from './SequenceDrillBlock';

export interface SequenceDrillItemProps {
  control: SequenceForm;
}

export const SequenceDrillItem = memo((props: SequenceDrillItemProps) => {
  const { control } = props;
  const items = useObservable(control.controls.items.items$, []);
  const itemValues = useObservable(control.controls.items.value$, []);

  useEffect(() => {
    if (items.length === 0) {
      control.controls.items.push();
    }
  }, [control.controls.items, items]);

  const onSortEnd = useCallback(
    (sort: SortEnd) => {
      const oldIndex = sort.oldIndex;
      const newIndex = sort.newIndex;
      const newSequenceAnswers = R.move(itemValues, oldIndex, newIndex);
      control.patchValue({
        items: newSequenceAnswers,
      });
    },
    [control, itemValues],
  );

  return (
    <Fragment>
      <Label>Answers</Label>
      <SortableList lockAxis="y" distance={2} onSortEnd={sort => onSortEnd(sort)} useDragHandle={true} helperClass="z5000">
        {items.map((ctrl, index) => {
          return <SortableSequenceAnswerItem key={index} index={index} ctrl={ctrl} form={control} i={index} />;
        })}
      </SortableList>
      {/* {items.map((ctrl, index) => {
        return (
          <React.Fragment key={`section-${index}`}>
            <Row>
              <Col md={9}>
                <FormInput control={ctrl.controls.item} />
              </Col>
              <Col md={3}>
                {!index && (
                  <a className="btn btn-outline-primary btn-sm" onClick={() => control.controls.items.push()}>
                    Add Item
                  </a>
                )}
                {!!index && (
                  <a className="btn btn-outline-danger btn-sm" onClick={() => control.controls.items.removeAt(index)}>
                    <i className="bx bx-x"></i>
                  </a>
                )}
              </Col>
            </Row>
          </React.Fragment>
        );
      })} */}
    </Fragment>
  );
});


interface SequenceAnswerItemProps {
  i: number;
  ctrl: SequenceItemForm;
  form: SequenceForm;
}

const SequenceAnswerItem = memo((props: SequenceAnswerItemProps) => {
  const { ctrl, form, i } = props;

  const DragHandle = SortableHandle(() => <i className="fas fa-grip-vertical font-size-16 mr-3 mb-3" style={{ cursor: 'move' }}></i>);

  return (
    <div>
      <Row key={`answer-${i} mb-2 mt-2`}>
        <Col md={10} className="input-width">
          <DragHandle />
          <FormInput control={ctrl.controls.item} />
        </Col>
        <Col md={2}>
          {!i && (
            <a className="btn btn-outline-primary btn-sm" onClick={() => form.controls.items.push()}>
              Add Item
            </a>
          )}
          {!!i && (
            <a className="btn btn-outline-danger btn-sm" onClick={() => form.controls.items.removeAt(i)}>
              <i className="bx bx-x"></i>
            </a>
          )}
        </Col>
      </Row>
    </div>
  );
});

export const SortableSequenceAnswerItem = SortableElement(SequenceAnswerItem);